"use client";

import { GAME_THEATER_PLAYER_BACKGROUND } from "@/lib/constants/layout";
import { cssVar, tokens } from "@/lib/constants/tokens";
import { cn } from "@/lib/utils";

interface GamePlayerLoadingOverlayProps {
  /** 0–100 when known (Unity); omit for indeterminate full bar (URL resolve / page fetch). */
  progress?: number;
  isMobile?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export function GamePlayerLoadingOverlay({
  progress,
  isMobile = false,
  className,
  style,
}: GamePlayerLoadingOverlayProps) {
  const progressWidth = progress === undefined ? "100%" : `${progress}%`;

  return (
    <div
      className={cn("absolute inset-0 flex flex-col justify-center items-center", className)}
      style={{ background: GAME_THEATER_PLAYER_BACKGROUND, ...style }}
      aria-busy="true"
      aria-label="Loading game"
    >
      <div className="flex flex-col items-center z-10">
        <img
          src="/loader.webp"
          alt=""
          className="mb-6"
          style={{
            width: "min(30vh, 30vw)",
            height: "min(30vh, 30vw)",
            objectFit: "contain",
          }}
          aria-hidden
        />

        <div
          className="relative mb-4"
          style={{
            width: isMobile ? "80vw" : "60vw",
            maxWidth: "400px",
            height: "12px",
            background: "rgba(255, 255, 255, 0.3)",
            border: "2px solid rgba(255, 255, 255, 0.5)",
            borderRadius: "20px",
            overflow: "hidden",
            backdropFilter: "blur(10px)",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            data-testid="game-player-progress-fill"
            style={{
              width: progressWidth,
              height: "100%",
              background: `linear-gradient(90deg, ${tokens.brandPurple} 0%, ${cssVar("brand-indigo-dark")} 50%, ${cssVar("brand-indigo-light")} 100%)`,
              transition: progress === undefined ? undefined : "width 0.3s ease",
              borderRadius: "18px",
              boxShadow: `0 0 20px ${cssVar("brand-purple", 0.5)}`,
            }}
          />
        </div>

        <div
          className={cn("text-white font-semibold", isMobile ? "text-base" : "text-lg")}
          style={{ textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)" }}
        >
          Loading...
        </div>
      </div>
    </div>
  );
}
